import { render, staticRenderFns } from "./COTTable.vue?vue&type=template&id=73335a54&"
import script from "./COTTable.vue?vue&type=script&lang=js&"
export * from "./COTTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports